import Vue from 'vue'
import global from '~/mixins/global'

Vue.mixin(global)
